module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lfx63"))).then(() => parcelRequire('1iHdE'));